<template lang="pug">
  .togglebutton
    .togglebutton_set(v-for="(value, index) in values")
      input.togglebutton_input(type="radio" v-bind:name="groupname" v-bind:value="value" v-bind:id="setId(index)" v-on:change="onChange" v-model="current")
      label.togglebutton_label(v-bind:for="setId(index)" v-bind:data-value="value.value") {{is_ja ? value.name : value.label}}
</template>
<script>
  import {mapState} from 'vuex';

  export default {
    props: ['selected', 'groupname', 'values'],
    data: function(){
      return {
        current: this.selected
      }
    },
    computed: {
      ...mapState([
        'lang',
      ]),
      is_ja(){
        return /ja/.test(this.lang)
      }
    },
    methods: {
      onChange: function(){
        this.$emit('toggle_change', this.current);
      },
      setId: function(index){
        return this.groupname + index;
      }

    },
    watch: {
      selected: function(val){
        this.current = val;
      }
    }


  }
</script>
<style lang="sass">
  .togglebutton
    display: flex
    &_set
      position: relative
      width: 60px
      height: 30px
      box-sizing: border-box
      & + &
        border-left: 1px solid #CCC
      &:first-child
        .togglebutton_label
          border-radius: 5px 0 0 5px
      &:last-child
        .togglebutton_label
          border-radius: 0 5px 5px 0
    &_input
      display: none
      &:checked
        & + .togglebutton_label
          background-color: #000
          color: #fff

    &_label
      font-size: 14px
      color: #666
      background-color: #fff
      transition: background-color .1s linear, color .1s linear
      width: 100%
      height: 100%
      display: flex
      justify-content: center
      align-items: center
      cursor: pointer
      &:hover
        background-color: #F0DC00


</style>